import React from 'react'
import './reset.css'
import { MainPage } from './containers'

function App () {
  return (
    <MainPage />
  )
}

export default App
